import { useTranslation } from 'react-i18next';

import ZodiacGlyph from './ZodiacGlyph';
import { capitalize, firstSentence, ordinal } from './chartGeometry';
import PLANET_IMAGES from './planetImages';
import styles from './styles.module.scss';

/** `planet` is a content.planets entry; `body` its placements.bodies match (or undefined). */
const PlanetCard = ({ planet, body }) => {
    const { t } = useTranslation();
    const meta = [
        body?.sign ? capitalize(body.sign) : '',
        body?.house ? t('birthChart.view.chart.houseLabel', { ordinal: ordinal(body.house) }) : ''
    ]
        .filter(Boolean)
        .join(' · ');
    const image = PLANET_IMAGES[planet.key];

    return (
        <article className={styles.planetCard}>
            <div className={styles.planetHead}>
                <h4 className={styles.planetName}>{planet.name}</h4>
                {body?.sign && (
                    <span className={styles.planetGlyph} aria-hidden="true">
                        <ZodiacGlyph sign={body.sign} size={18} />
                    </span>
                )}
            </div>
            {meta && <p className={styles.planetMeta}>{meta}</p>}
            <p className={styles.planetCopy}>{firstSentence(planet.copy)}</p>
            {image && <img className={styles.planetArt} src={image} alt="" loading="lazy" />}
        </article>
    );
};

export default PlanetCard;
